module.exports = __webpack_public_path__ + "img/homeStep.61b3ebb5.png";